// FROM: https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/components/MouseFieldPlaceholder/TextMousePlaceholder/index.tsx

import { FontType, TextAlign, TextFormat } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import TextFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextFieldPlaceHolder';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface TextMousePlaceholderProps {
  size: AbsoluteSize;
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  format: TextFormat | null;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function TextMousePlaceholder({
  size,
  fontFamily,
  fontSize,
  format,
  required,
  textAlign,
  participantOrder,
  scale,
}: TextMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <TextFieldPlaceholder
      fontPixelSize={fontPixelSize}
      format={format}
      participantOrder={participantOrder}
      rootElementSize={size}
      star={required}
      style={transformTextStyle}
    />
  );
}

TextMousePlaceholder.defaultProps = defaultProps;

export default TextMousePlaceholder;
